import { useState } from 'react'
import * as Comp from './card-shape.styles'
import type { TCardShapeProps } from './types'

const CardShapeRoot = ({
  children,
  testID,
  disabled,
  onPress,
  selected,
  ...rest
}: TCardShapeProps) => {
  const [isPressed, setIsPressed] = useState(false)

  const componentProperties = {
    testID,
    isDisabled: disabled,
    isPressed,
    onPress,
    isSelected: selected,
    ...rest,
  }

  return (
    <Comp.Root
      onPressOut={() => setIsPressed(false)}
      onPressIn={() => setIsPressed(true)}
      disabled={componentProperties.isDisabled}
      {...componentProperties}
    >
      <Comp.Slot>{children}</Comp.Slot>
    </Comp.Root>
  )
}

export const CardShape = {
  Root: CardShapeRoot,
}

export type { TCardShapeProps }
